<template>
<div class="d-flex justify-content-center align-items-center" style="height: 100vh">
    <div class="text-center">
        <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <p class="mt-2">Processing authentication...</p>
    </div>
</div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'SocialAuthCallback',
    data: () => ({
        loading: true
    }),
    mounted() {
        // Process the authentication callback
        this.handleAuthCallback();
    },
    methods: {
        async handleAuthCallback() {
            try {
                // Extract all query parameters from the URL
                const urlParams = new URLSearchParams(window.location.search);
                const queryParams = {};
                
                // Convert URLSearchParams to a plain object with all parameters
                for (const [key, value] of urlParams.entries()) {
                    queryParams[key] = value;
                }
                
                console.log('Auth callback received params:', queryParams);
                
                // Call API endpoint with all parameters
                const response = await axios.get(`${this.api}/auth/google/callback`, {
                    params: queryParams
                });
                
                console.log('Auth response:', response);
                
                if (response && response.data && response.data.access_token) {
                    this.loading = false;
                    this.$store.state.centralLogin = true;
                    this.$store.state.access_token = response.data.access_token;
                    this.setCookie('_MJC', response.data.access_token, 1);
                    this.$store.state.user = response.data.user;
                    
                    // Redirect based on role
                    if (response.data.user && response.data.user.role == 'admin') {
                        this.goTo('/leads');
                    } else if (response.data.user && response.data.user.role == 'superadmin') {
                        this.goTo('/campaigns');
                    } else if (response.data.user.role.includes('de_')) {
                        this.goTo('/bw-campaigns');
                    } else {
                        this.goTo('/leads');
                    }
                } else {
                    console.error('Invalid response from social auth endpoint');
                    this.$emit('snackbarNotification', `Authentication failed`, 'error');
                    this.goTo('/login');
                }
            } catch (error) {
                console.error('Authentication error:', error);
                // Redirect to login on error
                this.goTo('/login');
            }
        },
        setCookie(name, value, days) {
            var expires = "";
            var maxAge = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
                maxAge = "; max-age=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "") + expires + "; path=/";
        },
        goTo(path) {
            this.$router.push(path);
        },
    },
    computed: {
        api() {
            return this.$store.state.settings.apiBase;
        }
    }
}
</script>